/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Task_UpdatedInputs */

const cs_enum_task_updated = /** @type {(inputs: Enum_Task_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úkol upraven`)
};

const en_enum_task_updated = /** @type {(inputs: Enum_Task_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task updated`)
};

/**
* | output |
* | --- |
* | "Task updated" |
*
* @param {Enum_Task_UpdatedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_task_updated = /** @type {((inputs?: Enum_Task_UpdatedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Task_UpdatedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_task_updated(inputs)
	return cs_enum_task_updated(inputs)
});